import { Languages, Calculator, Monitor, Trophy, Mic, BookText, Check } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/site";

const cards = [
  { icon: Languages, title: "Languages", desc: "English, Spanish/German, Sanskrit & Hindi.", span: "md:col-span-4", tone: "primary" },
  { icon: Mic, title: "Spoken English", desc: "Fluency, confidence & everyday conversation.", span: "md:col-span-4", tone: "white", border: "border-4 border-primary" },
  { icon: BookText, title: "English Programs", desc: "Grammar · Writing · Comprehension · Vocabulary.", span: "md:col-span-4", tone: "white", border: "border-4 border-secondary" },
  { icon: Calculator, title: "Vedic Maths & Abacus", desc: "Mental-math superpowers and lightning calculation.", span: "md:col-span-5", tone: "secondary", img: true },
  { icon: Monitor, title: "Computer Education", desc: "Tailored programs matched to each student's goals.", span: "md:col-span-3", tone: "white", border: "border-4 border-primary" },
  { icon: Trophy, title: "Olympiad Prep", desc: "Structured coaching to excel in competitive exams.", span: "md:col-span-4", tone: "accent" },
];

const toneClass = {
  primary: "bg-primary text-primary-foreground",
  secondary: "bg-secondary text-secondary-foreground",
  accent: "bg-accent text-accent-foreground",
  white: "bg-white text-foreground",
};

export const AdditionalCourses = () => (
  <section id="additional-courses" className="py-24 md:py-32 max-w-7xl mx-auto px-5 md:px-8">
    <Reveal>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <Overline>Additional courses</Overline>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight max-w-xl">Skills that go beyond the syllabus.</h2>
        </div>
        <div className="rounded-2xl bg-muted px-5 py-4 max-w-sm" data-testid="additional-packages">
          <div className="font-heading font-bold text-lg mb-2">Packages</div>
          <ul className="space-y-2">
            {[
              "Monthly Plan: 2–3 classes every week",
              "Yearly Plan: 65 classes, valid for 12 months",
              "Weekend classes & small-group options available",
            ].map((pt) => (
              <li key={pt} className="flex items-start gap-2 text-sm text-muted-foreground">
                <Check size={16} className="text-secondary shrink-0 mt-0.5" />
                <span>{pt}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Reveal>

    <div className="grid md:grid-cols-12 gap-5 mt-12">
      {cards.map((c, i) => {
        const Icon = c.icon;
        return (
          <Reveal key={c.title} delay={0.05 * i} className={c.span}>
            <div className={`relative rounded-3xl p-7 md:p-8 h-full overflow-hidden hover:-translate-y-2 transition-transform duration-300 ${toneClass[c.tone]} ${c.border || ""}`}>
              {c.img && <img src={IMAGES.boy} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25 mix-blend-overlay" />}
              <div className="relative">
                <Icon size={30} className="mb-5" />
                <h3 className="font-heading font-bold text-2xl">{c.title}</h3>
                <p className={`mt-2 text-sm ${c.tone === "white" ? "text-muted-foreground" : "opacity-90"}`}>{c.desc}</p>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);

export default AdditionalCourses;
